import { Enums } from '@bode-canada/core';
import { MapZoomLevel } from '@/components/maps/enums';
import { LISTING_STATUS_SOLD_OPTION } from '@/components/filters/constants/options';

const {
  BuildingClassEnum,
  BuildingTypeEnum,
  ListingOriginEnum,
  OccupancyEnum,
} = Enums;

export const DEFAULT_SEARCH_PROPERTY_TYPES = [
  BuildingClassEnum.DETACHED,
  BuildingClassEnum.ROW_TOWNHOUSE,
  BuildingClassEnum.SEMI_DETACHED,
  BuildingTypeEnum.HIGH_RISE_APARTMENT,
  BuildingTypeEnum.VACANT_LAND,
  BuildingTypeEnum.LOW_RISE_APARTMENT,
];
export const DEFAULT_MIN_BEDS = null;
export const DEFAULT_MAX_BEDS = null;
export const DEFAULT_MIN_BATHS = null;
export const DEFAULT_MIN_PRICE = null;
export const DEFAULT_MAX_PRICE = null;
export const DEFAULT_ALBERTA_LISTING_TYPE = [ListingOriginEnum.BODE];
export const DEFAULT_LISTING_TYPE = [];
export const DEFAULT_LISTING_STATUS = [
  LISTING_STATUS_SOLD_OPTION,
];
export const DEFAULT_MIN_PARKING_SPACES = null;
export const DEFAULT_MIN_GARAGE_SPACES = null;
export const DEFAULT_IS_CONDO_EXCLUDED = false;
export const TENANT_OCCUPANCY_STATUS = OccupancyEnum.TENANT;
export const NO_TENANTS_OCCUPANCY_STATUS = OccupancyEnum.VACANT;

export const EMPTY_SEARCH_DATA = {
  minLat: null,
  minLon: null,
  maxLat: null,
  maxLon: null,
  center: null,
  bounds: null,
  zoom: MapZoomLevel.XSmall,
  sort: 'price_desc',
  minBeds: DEFAULT_MIN_BEDS,
  maxBeds: DEFAULT_MAX_BEDS,
  minBaths: DEFAULT_MIN_BATHS,
  minParkingSpaces: DEFAULT_MIN_PARKING_SPACES,
  minGarageSpaces: DEFAULT_MIN_GARAGE_SPACES,
  minPrice: DEFAULT_MIN_PRICE,
  maxPrice: DEFAULT_MAX_PRICE,
  minLotSizeAcres: null,
  maxLotSizeAcres: null,
  minFinishedSqft: null,
  maxFinishedSqft: null,
  minYearBuilt: null,
  maxYearBuilt: null,
  searchAddress: '',
  isCondoExcluded: DEFAULT_IS_CONDO_EXCLUDED,
  propertyType: [],
  listingType: [],
  listingStatus: [],
  parkingTypes: [],
  occupancyStatuses: [],
  suiteAvailability: [],
};
export const DEFAULT_SEARCH_DATA = {
  ...EMPTY_SEARCH_DATA,
  listingStatus: [...DEFAULT_LISTING_STATUS],
  propertyType: [...DEFAULT_SEARCH_PROPERTY_TYPES],
};
